import { render } from "./HzbaButton.vue?vue&type=template&id=5f858d34&scoped=true"
const script = {}

import "./HzbaButton.vue?vue&type=style&index=0&id=5f858d34&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f858d34"]])

export default __exports__